import classNames from 'classnames';

import { formattedDate } from 'util/index';

import Button from '@mui/material/Button';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        unenrolledBannerContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        unenrolledBanner: {
            display: 'flex',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            gap: '16px',
            '@media (max-width: 768px)': {
                gap: '8px'
            }
        },
        unsuccessful: {
            textTransform: 'uppercase'
        },
        reenrollButton: {
            alignSelf: 'flex-end',
            padding: '4px 12px',
            color: '#7378E8',
            border: '1px solid #7378E8',
            borderRadius: '20px',
            fontWeight: 700,
            textTransform: 'none',
            margin: '10px 30px',
            zIndex: 1,
            '& i': {
                marginLeft: '10px'
            },
            '@media (max-width: 768px)': {
                padding: '4px 8px',
                fontSize: '12px',
                margin: '10px'
            }
        }
    })
);

type LatestReinstateRequest = {
    status?: string;
    updated_at?: string;
};

type UnenrollHeaderProps = {
    exited: boolean;
    unsuccessful: boolean;
    unenrolled_on: null | string;
    latestReinstateRequest?: LatestReinstateRequest | null;
    setReenroll: (value: boolean) => void;
};

export const extensionRequestStatusLabel = (
    request?: LatestReinstateRequest | null
): string | null => {
    if (request?.status === 'pending') return 'EXTENSION REQUEST PENDING';
    if (request?.status === 'cancelled') return 'EXTENSION REQUEST DENIED';
    if (request?.status === 'completed') return 'EXTENSION APPROVED';
    return null;
};

export const withExtensionRequestStatus = (
    label: string,
    request?: LatestReinstateRequest | null
): string => {
    const status = extensionRequestStatusLabel(request);
    return status ? `${label} (${status})` : label;
};

const UnenrollHeader: React.FC<UnenrollHeaderProps> = ({
    exited,
    unsuccessful,
    unenrolled_on,
    latestReinstateRequest,
    setReenroll
}) => {
    const classes = useStyles();

    const bannerClass = classNames({
        [classes.unenrolledBanner]: true,
        [classes.unsuccessful]: unsuccessful
    });
    const membershipLabel = exited
        ? `Unenrolled on: ${unenrolled_on ? formattedDate(unenrolled_on) : ''}`
        : 'Pending Membership Ended';

    return (
        <div className={classes.unenrolledBannerContainer}>
            <span className={bannerClass}>
                <span>{withExtensionRequestStatus(membershipLabel, latestReinstateRequest)}</span>
            </span>
            {!unsuccessful && !exited && (
                <Button
                    className={classes.reenrollButton}
                    onClick={() => setReenroll(true)}
                >
                    Re-Enroll
                    <i className="fas fa-chevron-right" />
                </Button>
            )}
        </div>
    );
};

export default UnenrollHeader;
